// micrommodal
import MicroModal from 'micromodal';

document.addEventListener('DOMContentLoaded', (event) => {
  // モーダルを初期化
  MicroModal.init({
    disableScroll: true,
    disableFocus: true,
    onShow: (modal) => {
      const headerNavigationButton = document.querySelector(
        '.headerNavigationButton'
      );
      if (headerNavigationButton) {
        headerNavigationButton.classList.add('is-modal-open');
      }
    },
    onClose: (modal) => {
      const headerNavigationButton = document.querySelector(
        '.headerNavigationButton'
      );
      if (headerNavigationButton) {
        headerNavigationButton.classList.remove('is-modal-open');
      }
    },
  });
});
